import React, { useEffect, useState } from 'react'

import { deleteCourse } from '../utils/Network'
import { getDefaultName, isAdmin } from '../utils';
import ParticipantsCount from '../components/ParticipantsCount';
import TalentName from "../components/TalentName";
import { ApiHttpService } from '../utils/http/api';
import CourseCardsWidget from './course/widgets/CourseCardsWidget';

export default function CoursesContent() {

    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [courses, setCourses] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [show_as_boxes, setShowAsBoxes] = useState(true);

    useEffect(() => {
        setPageLoading(true)
        ApiHttpService.loadCoursesForAdmin().then(data => {
            setCourses(data.results);
            setPageLoading(false)
        });
    }, []);

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteCourse(id).then(() => {
            ApiHttpService.loadCoursesForAdmin().then(data => {
                setCourses(data.results);
            });;
        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    const showList = (e) => {
        e.preventDefault();
        setShowAsBoxes(!show_as_boxes)
    }


    return (
        <>
            <div className="content-wrapper">
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary mt-0 border-top-0 ">
                                <div className="box-header with-border">
                                    <h3 className="box-title ">
                                        Contests{' '}
                                        <span style={{ fontSize: 11 }}>({courses && courses.length})</span>
                                    </h3>
                                    {isAdmin() && <>
                                        <a href="/cms/course" title="Add New" className="btn btn-cm margin-r-5 pull-right "><i className="fa fa-plus"></i></a>
                                        <button title="Show Delete Button" type="button" className="btn btn-cm margin-r-5 pull-right " onClick={showDelete}><i className="fa fa-trash"></i></button>
                                        <button title="Change View" type="button" className="btn btn-cm margin-r-5 pull-right " onClick={showList}>
                                            <i className={`fa ${show_as_boxes ? 'fa-list' : 'fa-th'}`}></i>
                                        </button>
                                        <a href="/cms/coursehistories" title="Course History" className="btn btn-cm margin-r-5 pull-right "><i className="fa fa-history"></i></a>
                                        <a href="/cms/coursedocuments" title="Competitions Documents" className="btn btn-cm margin-r-5 pull-right "><i className="fa fa-file"></i></a>
                                        <a href="/cms/ratings" title="Ratings Summary" className="btn btn-cm margin-r-5 pull-right "><i className="fa fa-star"></i></a>
                                    </>}
                                </div>

                                <div className="box-body">
                                {pageloading && (
                                    <p className="text-center" style={{ color: '#7a9ab8' }}>Loading…</p>
                                )}
                                {show_as_boxes && courses && (
                                    <CourseCardsWidget
                                        courses={courses}
                                        showDelete={show_delete}
                                        loading={loading}
                                        onDelete={handleDelete}
                                    />
                                )}

                                {!show_as_boxes && courses && (
                                    <div className="cms-course-table-wrap cm-panel">
                                        <table id="example1" className="table table-striped cms-widget-table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th className="hide-on-small">Talent</th>
                                                    <th className="hide-on-small">Status</th>
                                                    <th className="hide-on-small">Start</th>
                                                    <th className="hide-on-small">End</th>
                                                    <th>Participants</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {courses.map((item) => (
                                                    <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                        <td>
                                                            <p>
                                                                <a href={`/cms/coursedetails/${item.id}`}>{getDefaultName(item.names)}</a>
                                                            </p>
                                                            <div className="btn-group">
                                                                {show_delete &&
                                                                    <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                }
                                                                <a href={`/cms/course/${item.id}`} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-edit"></i>
                                                                </a>
                                                                <a href={`/cms/coursedetails/${item.id}`} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-bar-chart"></i>
                                                                </a>

                                                            </div>
                                                        </td>
                                                        <td className="hide-on-small">
                                                            {item.talents && item.talents.length > 0
                                                                ? item.talents.map((tid, ti) => (
                                                                    <span key={typeof tid === "object" ? tid.id : tid}>
                                                                        {ti > 0 ? ", " : ""}
                                                                        <TalentName id={typeof tid === "object" ? tid.id : tid} />
                                                                    </span>
                                                                ))
                                                                : item.talent
                                                                ? <TalentName id={item.talent} />
                                                                : "-"}
                                                        </td>
                                                        <td className="hide-on-small">
                                                            {item.status ? "Open" : "Closed"}
                                                            {item.staff_preview ? " · Staff preview" : ""}
                                                        </td>
                                                        <td className="hide-on-small">{item.startdate}</td>
                                                        <td className="hide-on-small">{item.enddate}</td>
                                                        <td><ParticipantsCount course_id={item.id} /></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Name</th>
                                                    <th className="hide-on-small">Talent</th>
                                                    <th className="hide-on-small">Status</th>
                                                    <th className="hide-on-small">Start</th>
                                                    <th className="hide-on-small">End</th>
                                                    <th>Participants</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>


    )
}
